module.exports = __webpack_public_path__ + "assets-cabinet/img/Rolling-loading.6506e3c4.svg";